import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/login`, {
        username,
        password,
      });

      const { token, role } = response.data;

      // ✅ decodificar username desde el token sin romper si algo va mal
      let usernameFromToken = "";
      try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        usernameFromToken = payload.username;
      } catch (decodeError) {
        console.error("❌ No se pudo decodificar el token:", decodeError);
      }

      localStorage.setItem("token", token);
      localStorage.setItem("role", role);
      localStorage.setItem("username", usernameFromToken);

      if (role === "admin") {
        navigate("/admin");
      } else if (role === "standard") {
        navigate("/formulario");
      } else if (role === "supervisor") {
        navigate("/supervisor");
      } else {
        setError("Rol no reconocido.");
      }

    } catch (err) {
      console.error("Error en login:", err.response?.data || err.message);
      setError("Credenciales incorrectas");
    }
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center vh-100"
      style={{
        flexDirection: "column",
        backgroundImage: "url('/images/fondo.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
      }}
    >
      <img src="/images/logo.jpg" alt="Logo" style={{ width: "150px", marginBottom: "20px" }} />
      <div
        className="card p-4 shadow"
        style={{
          width: "350px",
          background: "rgba(255, 255, 255, 0.7)",
          borderRadius: "10px",
          textAlign: "center"
        }}
      >
        <h3 className="text-center text-primary">Iniciar Sesión</h3>
        {error && <div className="alert alert-danger">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Nombre de Usuario</label>
            <input
              type="text"
              className="form-control"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoComplete="username"
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Contraseña</label>
            <input
              type="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
          </div>
          <button type="submit" className="btn btn-primary w-100">Ingresar</button>
        </form>
      </div>
    </div>
  );
};

export default Login;
